import Edit from './Edit';
import List from './List';
import Show from './Show';

export default {
  name: 'hris_specialty_mappings',
  list: List,
  show: Show,
  edit: Edit,
  options: {
    label: 'HRIS Specialty Mappings',
    group: false,
  },
};
